import { ToolbarDropdown } from './dropdown/_dropdown.js';
import { isSupportedComponentNode } from './typings.component-nodes.js';
import { jsx } from 'react/jsx-runtime';

function ElementToolbar(props) {
  if (!isSupportedComponentNode(props.node)) {
    return null;
  }
  return /*#__PURE__*/jsx(ToolbarDropdown, {
    node: props.node,
    customPosition: props.customPosition
  });
}

export { ElementToolbar };
//# sourceMappingURL=element-toolbar.js.map
